"use client";

import _slicedToArray from "/codebuild/output/src859445700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/codebuild/output/src859445700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/codebuild/output/src859445700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { applyState, chain, getKeys, hasOwnProperty, invariant, noop, omit, pick } from "./PBFD2E7P.js";
import { __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/utils/store.ts
function getInternal(store, key) {
  var internals = store.__unstableInternals;
  invariant(internals, "Invalid store");
  return internals[key];
}
function createStore(initialState) {
  for (var _len = arguments.length, stores = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    stores[_key - 1] = arguments[_key];
  }
  var state = initialState;
  var prevStateBatch = state;
  var lastUpdate = Symbol();
  var destroy = noop;
  var instances = /* @__PURE__ */new Set();
  var updatedKeys = /* @__PURE__ */new Set();
  var setups = /* @__PURE__ */new Set();
  var listeners = /* @__PURE__ */new Set();
  var batchListeners = /* @__PURE__ */new Set();
  var disposables = /* @__PURE__ */new WeakMap();
  var listenerKeys = /* @__PURE__ */new WeakMap();
  var storeSetup = function storeSetup(callback) {
    setups.add(callback);
    return function () {
      return setups.delete(callback);
    };
  };
  var storeInit = function storeInit() {
    var initialized = instances.size;
    var instance = Symbol();
    instances.add(instance);
    var maybeDestroy = function maybeDestroy() {
      instances.delete(instance);
      if (instances.size) return;
      destroy();
    };
    if (initialized) return maybeDestroy;
    var desyncs = getKeys(state).map(function (key) {
      return chain.apply(void 0, _toConsumableArray(stores.map(function (store) {
        var _a;
        var storeState = (_a = store == null ? void 0 : store.getState) == null ? void 0 : _a.call(store);
        if (!storeState) return;
        if (!hasOwnProperty(storeState, key)) return;
        return sync(store, [key], function (state2) {
          setState(key, state2[key],
          // @ts-expect-error - Not public API. This is just to prevent
          // infinite loops.
          true);
        });
      })));
    });
    var teardowns = [];
    var _iterator = _createForOfIteratorHelper(setups),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var setup2 = _step.value;
        teardowns.push(setup2());
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var cleanups = stores.map(init);
    destroy = chain.apply(void 0, _toConsumableArray(desyncs).concat(teardowns, _toConsumableArray(cleanups)));
    return maybeDestroy;
  };
  var sub = function sub(keys, listener) {
    var set = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : listeners;
    set.add(listener);
    listenerKeys.set(listener, keys);
    return function () {
      var _a;
      (_a = disposables.get(listener)) == null ? void 0 : _a();
      disposables.delete(listener);
      listenerKeys.delete(listener);
      set.delete(listener);
    };
  };
  var storeSubscribe = function storeSubscribe(keys, listener) {
    return sub(keys, listener);
  };
  var storeSync = function storeSync(keys, listener) {
    disposables.set(listener, listener(state, state));
    return sub(keys, listener);
  };
  var storeBatch = function storeBatch(keys, listener) {
    disposables.set(listener, listener(state, prevStateBatch));
    return sub(keys, listener, batchListeners);
  };
  var storePick = function storePick(keys) {
    return createStore(pick(state, keys), finalStore);
  };
  var storeOmit = function storeOmit(keys) {
    return createStore(omit(state, keys), finalStore);
  };
  var getState = function getState() {
    return state;
  };
  var setState = function setState(key, value) {
    var fromStores = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _a;
    if (!hasOwnProperty(state, key)) return;
    var nextValue = applyState(value, state[key]);
    if (nextValue === state[key]) return;
    if (!fromStores) {
      for (var _i = 0, _stores = stores; _i < _stores.length; _i++) {
        var store = _stores[_i];
        (_a = store == null ? void 0 : store.setState) == null ? void 0 : _a.call(store, key, nextValue);
      }
    }
    var prevState = state;
    state = __spreadProps(__spreadValues({}, state), _defineProperty({}, key, nextValue));
    var thisUpdate = Symbol();
    lastUpdate = thisUpdate;
    updatedKeys.add(key);
    var run = function run(listener, prev, uKeys) {
      var _a2;
      var keys = listenerKeys.get(listener);
      var updated = function updated(k) {
        return uKeys ? uKeys.has(k) : k === key;
      };
      if (!keys || keys.some(updated)) {
        (_a2 = disposables.get(listener)) == null ? void 0 : _a2();
        disposables.set(listener, listener(state, prev));
      }
    };
    var _iterator2 = _createForOfIteratorHelper(listeners),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var listener = _step2.value;
        run(listener, prevState);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    queueMicrotask(function () {
      if (lastUpdate !== thisUpdate) return;
      var snapshot = state;
      var _iterator3 = _createForOfIteratorHelper(batchListeners),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var listener = _step3.value;
          run(listener, prevStateBatch, updatedKeys);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      prevStateBatch = snapshot;
      updatedKeys.clear();
    });
  };
  var finalStore = {
    getState: getState,
    setState: setState,
    __unstableInternals: {
      setup: storeSetup,
      init: storeInit,
      subscribe: storeSubscribe,
      sync: storeSync,
      batch: storeBatch,
      pick: storePick,
      omit: storeOmit
    }
  };
  return finalStore;
}
function setup(store) {
  if (!store) return;
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  return getInternal(store, "setup").apply(void 0, args);
}
function init(store) {
  if (!store) return;
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  return getInternal(store, "init").apply(void 0, args);
}
function subscribe(store) {
  if (!store) return;
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }
  return getInternal(store, "subscribe").apply(void 0, args);
}
function sync(store) {
  if (!store) return;
  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }
  return getInternal(store, "sync").apply(void 0, args);
}
function batch(store) {
  if (!store) return;
  for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    args[_key6 - 1] = arguments[_key6];
  }
  return getInternal(store, "batch").apply(void 0, args);
}
function omit2(store) {
  if (!store) return;
  for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }
  return getInternal(store, "omit").apply(void 0, args);
}
function pick2(store) {
  if (!store) return;
  for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
    args[_key8 - 1] = arguments[_key8];
  }
  return getInternal(store, "pick").apply(void 0, args);
}
function mergeStore() {
  for (var _len9 = arguments.length, stores = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    stores[_key9] = arguments[_key9];
  }
  var initialState = stores.reduce(function (state, store2) {
    var _a;
    var nextState = (_a = store2 == null ? void 0 : store2.getState) == null ? void 0 : _a.call(store2);
    if (!nextState) return state;
    return Object.assign(state, nextState);
  }, {});
  var store = createStore.apply(void 0, [initialState].concat(stores));
  return Object.assign.apply(Object, [{}].concat(stores, [store]));
}
function throwOnConflictingProps(props, store) {
  if (process.env.NODE_ENV === "production") return;
  if (!store) return;
  var defaultKeys = Object.entries(props).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return key.startsWith("default") && value !== void 0;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      key = _ref4[0];
    var _a;
    var stateKey = key.replace("default", "");
    return "".concat(((_a = stateKey[0]) == null ? void 0 : _a.toLowerCase()) || "").concat(stateKey.slice(1));
  });
  if (!defaultKeys.length) return;
  var storeState = store.getState();
  var conflictingProps = defaultKeys.filter(function (key) {
    return hasOwnProperty(storeState, key);
  });
  if (!conflictingProps.length) return;
  throw new Error("Passing a store prop in conjunction with a default state is not supported.\n\nconst store = useSelectStore();\n<SelectProvider store={store} defaultValue=\"Apple\" />\n                ^             ^\n\nInstead, pass the default state to the topmost store:\n\nconst store = useSelectStore({ defaultValue: \"Apple\" });\n<SelectProvider store={store} />\n\nSee https://github.com/ariakit/ariakit/pull/2745 for more details.\n\nIf there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit\n");
}
export { createStore, setup, init, subscribe, sync, batch, omit2 as omit, pick2 as pick, mergeStore, throwOnConflictingProps };